import { render, staticRenderFns } from "./personIcon.vue?vue&type=template&id=3e039cff&"
import script from "./personIcon.vue?vue&type=script&lang=js&"
export * from "./personIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports